import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/config';

const namespace = 'LITIGATION';

export const CONFIG_FETCH_START = `${namespace}/CONFIG_FETCH_START`;
export const CONFIG_FETCH_SUCCESS = `${namespace}/CONFIG_FETCH_SUCCESS`;
export const CONFIG_FETCH_ERROR = `${namespace}/CONFIG_FETCH_ERROR`;

export const fetchCodefileConfig = makeApiActionCreatorV3(
  api.fetchCodefileConfig,
  CONFIG_FETCH_START,
  CONFIG_FETCH_SUCCESS,
  CONFIG_FETCH_ERROR,
);
